<template>
  <div class="main pa-3">
    <!-- <v-data-table
      :loading="loading"
      :headers="headers"
      :page.sync="page"
      :items-per-page="limit"
      @page-count="pageCount"
      hide-default-footer
      :items="teachers"
      class="pa-5 ma-md-5 font-weight-light"
      elevation="3"
    >-->

    <v-row class="mx-1 mb-8">
      <v-col class="display-1 font-weight-light">Instructor Registration</v-col>
    </v-row>
    <v-data-table
      :loading="loading"
      :headers="headers"
      hide-default-footer
      :items="teachers"
      class="pa-mb-5 mx-3 font-weight-light"
    >
      <template v-slot:top>
        <v-toolbar flat class="table-header mb-2" color="rgb(241, 243, 245)">
          <!-- <div class="mr-md-5 xs-full-width">
            <v-text-field
              outlined
              rounded
              v-model="searchdata"
              @change="searchInfo(searchdata)"
              placeholder="Search"
              clearable
            ></v-text-field>
          </div>-->

          <div class="mr-md-7 xs-full-width mt-1 mb-10">
            <span class="caption title-text font-weight-black">SEARCH</span>
            <v-text-field
              class="subtitle-2 text-field-border"
              solo
              flat
              dense
              v-model="searchdata"
              @change="searchInfo(searchdata)"
              placeholder="Search name"
              clearable
            ></v-text-field>
          </div>

          <!-- <div class="mr-md-5">
            <v-autocomplete
              v-model="searchby"
              @change="onSort"
              :items="searchType"
              rounded
              outlined
              placeholder="Search By"
            ></v-autocomplete>
          </div>-->

          <!-- <div class="mr-md-3 mt-3">
            <div class="mr-md-5 xs-full-width">
              <div class="caption font-weight-black title-text">USER STATUS</div>
              <v-btn-toggle
                color="primary accent-3"
                background-color="white"
                mandatory
                v-model="status_toggle"
                @change="onSort"
              >
                <v-btn class="text-capitalize body-2 font-weight-light" height="40px">All</v-btn>
                <v-btn class="text-capitalize body-2 font-weight-light" height="40px">Teacher</v-btn>
                <v-btn class="text-capitalize body-2 font-weight-light" height="40px">Student</v-btn>
              </v-btn-toggle>
            </div>
          </div> -->

          <!-- <div class="ml-5 xs-full-width">
            <v-btn
              color="success"
              outlined
              rounded
              large
              @click="refreshFilter"
              class="mb-7 pl-5 pr-5 xs-full-width title"
            >
              <v-icon left>mdi-cached</v-icon>{{$vuetify.lang.t("$vuetify.courseManagement.filterBar.refresh")}}
            </v-btn>
          </div>-->

          <div class="xs-full-width mb-10">
            <v-btn
              outlined
              @click="refreshFilter"
              height="40px"
              class="pl-5 pr-5 xs-full-width font-weight-light button-secondary body-2 text-capitalize mt-8"
            >
              <v-icon left>mdi-cached</v-icon>
              {{$vuetify.lang.t("$vuetify.courseManagement.filterBar.refresh")}}
            </v-btn>
          </div>
        </v-toolbar>
      </template>
      <template v-slot:item.image="{ item }">
        <!-- <v-avatar :color="`grey lighten-2`" elevation="3" size="100" class="my-2"> -->
        <v-img
          :src="item.image == null ? imageReady : item.image"
          class="my-3 ml-auto mr-auto rounded-card img-md"
          aspect-ratio="1"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-icon v-if="imageReady" class="mx-auto" elevation="3" size="100">mdi-account</v-icon>
            </v-row>
          </template>
        </v-img>
        <!-- </v-avatar> -->
      </template>
      <template v-slot:item.fullName="{ item }">
        <span class="md-fixed-width text-left body-2 font-weight-light">{{item.fullName}}</span>
      </template>
      <!-- <template v-slot:item.email="{ item }">
        <span class="md-fixed-width text-left body-2 font-weight-light">{{item.email}}</span>
      </template> -->
      <template v-slot:item.username="{ item }">
        <span class="md-fixed-width text-left body-2 font-weight-light">{{item.username}}</span>
      </template>
      <!-- <template v-slot:item.course="{ item }">
        <v-row>
          <p class="my-2 xs-fixed-width max-width text-center">สร้างคอร์ส {{item.course.create}}</p>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <p class="my-2 xs-fixed-width max-width text-center">กำลังเรียน {{item.course.buy}}</p>
        </v-row>
      </template>-->

      <!-- <template v-slot:item.course="{ item }">
        <div class="max-width">
          <v-chip small class="mt-2 mb-1 body-2">สร้างคอร์ส {{item.course.create}}</v-chip>
        </div>
        <div class="max-width">
          <v-chip small class="mb-2 body-2">กำลังเรียน {{item.course.buy}}</v-chip>
        </div>
      </template> -->

      <template v-slot:item.group="{ item }">
        <!-- <v-chip-group column class>
          <v-chip small class="ma-2" v-for="group in item.group" :key="group._id">
            <p class="mb-0">{{ group.title }}</p>
          </v-chip>
        </v-chip-group>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mb-2"
              fab
              outlined
              x-small
              color="primary"
              v-on="on"
              @click="$store.state.permission.updateStudent == true ? getUserGroup(item) : noPermission()"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">แก้ไขกลุ่ม</span>
        </v-tooltip>-->

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="text-capitalize button-secondary body-2 font-weight-light"
              small
              elevation="0"
              v-on="on"
              @click="$store.state.permission.updateStudent == true ? getUserGroup(item) : noPermission()"
            >
              {{item.group.length}} Group
              <span v-if="item.group.length > 1" class="text-lowercase">s</span>
            </v-btn>
          </template>
          <div class="text-center">
            <span class="subtitle-1 mx-2">CLICK TO EDIT GROUPS:</span>
          </div>
          <v-divider dark></v-divider>
          <v-chip-group column class="md-fixed-max-width">
            <v-chip label small class="ma-2" v-for="group in item.group" :key="group._id">
              <div class="mb-0 caption">{{group.title}}</div>
            </v-chip>
          </v-chip-group>
        </v-tooltip>
      </template>

      <!-- <template v-slot:item.type="{ item }">
        <v-chip class="my-2" :color="item.isTeacher=='w' ?'default':'primary'">
          <v-avatar left>
            <v-icon>{{item.isTeacher=='w' ? 'mdi-account' : 'mdi-account-tie'}}</v-icon>
          </v-avatar>
          <p class="mb-0">{{item.isTeacher=='w' ? 'ผู้ใช้ทั่วไป' : 'ครู/ผู้สอน'}}</p>
        </v-chip>
      </template> -->

      <!-- <template v-slot:item.active="{ item }"> -->
        <!-- <v-chip
          @click="$store.state.permission.activeStudent == true ? openModalStatus(item) : noPermission()"
          outlined
          :color="item.active==0 ?'red':'green'"
        >
          <v-avatar left>
            <v-icon x-small>mdi-checkbox-blank-circle</v-icon>
          </v-avatar>
          <p class="mb-0">{{item.active==0 ? 'ปิดใช้งาน' : 'เปิดใช้งาน'}}</p>
        </v-chip>-->

        <!-- <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-switch
                color="rgb(66, 154, 216)"
                inset
                v-model="item.active"
                @click="$store.state.permission.activeStudent == true ? openModalStatus(item) : noPermission()"
              ></v-switch>
            </div>
          </template>
          <span v-if="item.active">Click to Suspend</span>
          <span v-else>Click to Activate</span>
        </v-tooltip>
      </template> -->

      <template v-slot:item.approve="{ item }">
        <!-- <v-chip
          dark
          class="my-2"
          :color="item.isTeacher=='w' ? 'default': 'primary'"
          @click="setPermission(item)"
        >
          <v-avatar left>
            <v-icon>{{item.isTeacher=='w' ? 'mdi-clock' : 'mdi-check'}}</v-icon>
          </v-avatar>
          <p class="mb-0">{{item.isTeacher=='w'? 'รออนุมัติ' : 'อนุมัติแล้ว'}}</p>
        </v-chip> -->

        <div class="d-flex justify-center">
          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize font-weight-light"
            color="white"
            @click="$store.state.permission.updateStudent == true ? userConfirm(item) : noPermission()"
          >Approve</v-btn>
          <v-divider inset vertical class="mx-1 mb-2"></v-divider>
          <v-btn
            elevation="0"
            class="mb-0 body-2 red--text text-capitalize font-weight-light"
            color="white"
            @click="$store.state.permission.updateStudent == true ? reject(item) : noPermission()"
          >Not Approve</v-btn>
        </div>
      </template>

      <!-- <template v-slot:item.actions="{ item }">
        <div>
          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="$store.state.permission.updateStudent == true ? userEdit(item) : noPermission()"
          >Edit</v-btn>
        </div>
      </template> -->
    </v-data-table>

    <v-dialog v-model="dialogFormUser" scrollable persistent max-width="800px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <v-icon left>mdi-account-circle</v-icon>แก้ไข/เพิ่ม ผู้ใช้งาน
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="clearForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pr-0 pl-0">
          <v-tabs v-model="tab" fixed-tabs>
            <v-tab>ข้อมูลผู้ใช้งาน</v-tab>
            <v-tab>กำหนดสิทธิ์การเข้าถึง</v-tab>

            <v-tab-item class="pr-5 pl-5">
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <p>อัพโหลดรูปภาพ</p>
                      <v-file-input
                        v-model="imageFile"
                        @change="preview"
                        rounded
                        outlined
                        dense
                        show-size
                        accept="image/png, image/jpeg, image/bmp"
                        :label="imgPreview ? 'เลือกรูปภาพใหม่' : 'เลือกรูปภาพ'"
                        prepend-icon="mdi-camera"
                      ></v-file-input>
                      <div class="img-padding">
                        <v-avatar :color="`grey lighten-2`" elevation="3" size="200">
                          <v-img
                            :src="imgPreview == null ? imageReady : imgPreview"
                            aspect-ratio="1.8"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                                <v-icon
                                  v-if="imageReady"
                                  class="mx-auto"
                                  elevation="3"
                                  size="200"
                                >mdi-account</v-icon>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>
                      <!-- <v-skeleton-loader
                        v-if="!imageReady"
                        class="mx-auto"
                        type="card"
                        elevation="3"
                        contain
                        height="190"
                      ></v-skeleton-loader>-->
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <p>
                        เพศ
                        <span class="red--text">*</span>
                      </p>
                      <v-autocomplete
                        v-model="selectedGender"
                        :items="genders"
                        item-text="text"
                        item-value="value"
                        rounded
                        outlined
                        placeholder="เพศ"
                      ></v-autocomplete>
                      <p>
                        ชื่อจริง
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        rounded
                        outlined
                        :rules="firstNameRules"
                        clearable
                        placeholder="ชื่อจริง"
                        v-model="firstName"
                      ></v-text-field>
                      <p>
                        นามสกุล
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        rounded
                        outlined
                        :rules="lastNameRules"
                        clearable
                        placeholder="นามสกุล"
                        v-model="lastName"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <p>
                        อีเมล
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        rounded
                        outlined
                        :rules="emailRules"
                        clearable
                        placeholder="อีเมล"
                        v-model="email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <p>
                        Username
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        rounded
                        outlined
                        :rules="userNameRules"
                        clearable
                        placeholder="Username"
                        v-model="username"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="checkboxPasswordHide">
                      <v-checkbox v-model="checkboxPassword" label="อัปเดตรหัสผ่าน"></v-checkbox>
                    </v-col>
                    <v-col cols="6" v-if="checkboxPassword">
                      <p>
                        รหัสผ่าน
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        :type="showPassword ? 'text' : 'password'"
                        rounded
                        outlined
                        :rules="passwordRules"
                        clearable
                        placeholder="รหัสผ่าน"
                        v-model="password"
                        :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" v-if="checkboxPassword">
                      <p>
                        ยืนยันรหัสผ่าน
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        :type="showConFirmPassword ? 'text' : 'password'"
                        rounded
                        outlined
                        :rules="conFirmPasswordRules"
                        clearable
                        placeholder="ยืนยันรหัสผ่าน"
                        v-model="conFirmPassword"
                        :append-icon="!showConFirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showConFirmPassword = !showConFirmPassword"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" dark rounded outlined @click="dialog = false">ยกเลิก</v-btn>
                <v-btn color="primary" rounded :disabled="!valid" @click="insertOrUpdateUser">บันทึก</v-btn>
              </v-card-actions>-->
            </v-tab-item>
            <v-tab-item class="pr-5 pl-5">
              <v-form ref="form">
                <v-container>
                  <v-row>
                    <v-col cols="12" class="pt-0 pb-0">
                      <p class="headline mb-0">จัดการผู้ใช้งาน</p>
                    </v-col>
                    <v-col cols="12" class="ma-0 pt-0 pb-0">
                      <!-- <v-checkbox
                        label="เลือกทั้งหมด"
                        v-model="permissionStudentAll"
                        @change="selectStudentAll"
                      ></v-checkbox>-->
                    </v-col>
                    <v-col cols="6" class="ma-0 pt-0 pb-0">
                      <v-checkbox
                        label="เข้าถึงข้อมูลผู้ใช้งาน"
                        v-model="viewStudent"
                        @change="changeState"
                      ></v-checkbox>
                      <v-checkbox
                        label="แก้ไขรายชื่อผู้ใช้งาน"
                        v-model="updateStudent"
                        :disabled="!viewStudent"
                        @change="changeStateUpdate"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6" class="ma-0 pt-0 pb-0">
                      <v-checkbox
                        label="เพิ่มรายชื่อผู้ใช้งาน"
                        v-model="insertStudent"
                        :disabled="!viewStudent"
                        @change="changeStateUpdate"
                      ></v-checkbox>
                      <v-checkbox
                        label="ระงับการใช้งาน"
                        v-model="activeStudent"
                        :disabled="!insertStudent && !updateStudent"
                        @change="permissionStudentAll = false"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-5 mb-5"></v-divider>
                  <v-row>
                    <v-col cols="12" class="pt-0 pb-0">
                      <p class="headline mb-0">จัดการกลุ่มผู้ใช้งาน</p>
                    </v-col>
                    <v-col cols="12" class="ma-0 pt-0 pb-0">
                      <v-checkbox label="เข้าถึง/แก้ไข กลุ่มผู้ใช้งาน" v-model="userGroup"></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-5 mb-5"></v-divider>
                  <v-row>
                    <v-col cols="12" class="pt-0 pb-0">
                      <p class="headline mb-0">จัดการคอร์สเรียน</p>
                    </v-col>
                    <v-col cols="12" class="ma-0 pt-0 pb-0">
                      <!-- <v-checkbox
                        label="เลือกทั้งหมด"
                        v-model="permissionCourseAll"
                        @change="selectCourseAll"
                      ></v-checkbox>-->
                    </v-col>
                    <v-col cols="6" class="ma-0 pt-0 pb-0">
                      <v-checkbox
                        label="เข้าถึงรายการคอร์ส"
                        v-model="viewCourse"
                        @change="changeStateCourse"
                      ></v-checkbox>
                      <v-checkbox
                        label="แก้ไขคอร์สเรียน"
                        v-model="updateCourse"
                        :disabled="!viewCourse"
                        @change="changeStateUpdateCourse"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6" class="ma-0 pt-0 pb-0">
                      <v-checkbox
                        label="เพิ่มคอร์สเรียน"
                        v-model="insertCourse"
                        :disabled="!viewCourse"
                        @change="changeStateUpdateCourse"
                      ></v-checkbox>
                      <v-checkbox
                        label="ระงับการใช้งาน"
                        v-model="activeCourse"
                        :disabled="!insertCourse && !updateCourse"
                        @change="permissionCourseAll = false;"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-5 mb-5"></v-divider>
                  <v-row>
                    <v-col cols="12" class="pt-0 pb-0">
                      <p class="headline mb-0">จัดการหมวดหมู่</p>
                    </v-col>
                    <v-col cols="12" class="ma-0 pt-0 pb-0">
                      <v-checkbox label="จัดการเพิ่ม/แก้ไข/ลบ หมวดหมู่" v-model="manageCategory"></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-5 mb-5"></v-divider>
                  <v-row>
                    <v-col cols="12" class="pt-0 pb-0">
                      <p class="headline mb-0">เข้าถึงการรายงาน</p>
                    </v-col>
                    <v-col cols="12" class="ma-0 pt-0 pb-0">
                      <v-checkbox label="เข้าถึงรายงาน และ Dashboard" v-model="viewReport"></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-5 mb-5"></v-divider>
                </v-container>
              </v-form>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            class="px-9 ma-2"
            large
            dark
            rounded
            outlined
            @click="clearForm"
          >ยกเลิก</v-btn>
          <v-btn
            color="primary"
            class="px-10 ma-2"
            large
            rounded
            :disabled="!valid"
            @click="insertOrUpdateUser"
          >บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGroupUser" scrollable persistent max-width="800px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <v-icon left>mdi-account-circle</v-icon>จัดกลุ่มผู้ใช้งาน
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogGroupUser = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- <v-treeview
            v-model="selection"
            selectable
            selected-color="primary"
            :items="groupUsers"
            selection-type="leaf"
            item-children="child_User_Group"
            item-key="_id"
            item-text="title"
          ></v-treeview>-->
          <div>
            <br />
            <v-autocomplete
              v-model="selection"
              :items="arrayGroup"
              item-text="title"
              item-value="_id"
              append-icon="search"
              chips
              small-chips
              multiple
              rounded
              outlined
              placeholder="Please Choose the section"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeByUser(data.item)"
                >{{ data.item.title }}</v-chip>
              </template>
            </v-autocomplete>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            class="px-9 ma-2"
            large
            dark
            rounded
            outlined
            @click="dialogGroupUser = false"
          >ยกเลิก</v-btn>
          <v-btn
            color="primary"
            class="px-10 ma-2"
            large
            rounded
            :disabled="!valid"
            @click="insertOrUpdateUserGroup"
          >บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUserConfirm" scrollable persistent max-width="800px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <v-icon left>mdi-account-check</v-icon>การยืนยันตัวตนเป็น Teacher/Tutor
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pr-5 pl-5">
          <v-form ref="form" v-model="valid3">
            <v-container>
              <v-row>
                <v-col cols="8">
                  <div class="img-padding">
                    <v-avatar :color="`grey lighten-2`" elevation="3" size="80">
                      <v-img
                        :src="image == null ? imageProfileReady  : image"
                        class="my-2 ml-auto mr-auto rounded-card img-md"
                        aspect-ratio="1"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-icon
                              v-if="imageProfileReady"
                              class="mx-auto"
                              elevation="3"
                              size="80"
                            >mdi-account</v-icon>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <p class="ma-2 px-5 text-left font-weight-bold title">{{fullName}}</p>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <p class="ma-2 px-5 text-left subtitle">{{email}}</p>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="chip-padding">
                    <v-chip class="my-5" color="default">
                      <v-avatar left>
                        <v-icon>mdi-account</v-icon>
                      </v-avatar>
                      <p class="mb-0">ผู้ใช้ทั่วไป</p>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <p>หลักฐานที่ 1</p>
                  <v-card class="ma-5" :color="`grey lighten-2`" elevation="3">
                    <v-img
                      :src="imgPreview1 == null ? imageReady1 : imgPreview1"
                      aspect-ratio="1"
                      contain
                      height="190"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          <v-icon
                            v-if="imageReady1"
                            class="mx-auto"
                            elevation="3"
                            size="190"
                          >mdi-card-account-details-outline</v-icon>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                  <!-- <v-skeleton-loader
                    v-if="!imageReady1"
                    class="mx-auto"
                    type="card"
                    elevation="3"
                    contain
                    height="190"
                  ></v-skeleton-loader>-->
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <p>หลักฐานที่ 2</p>
                  <v-card class="ma-5" :color="`grey lighten-2`" elevation="3">
                    <v-img
                      :src="imgPreview2 == null ? imageReady2 : imgPreview2"
                      aspect-ratio="1"
                      contain
                      height="190"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          <v-icon
                            v-if="imageReady2"
                            class="mx-auto"
                            elevation="3"
                            size="190"
                          >mdi-card-account-details-outline</v-icon>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                  <!-- <v-skeleton-loader
                    v-if="!imageReady2"
                    class="mx-auto"
                    type="card"
                    elevation="3"
                    contain
                    height="190"
                  ></v-skeleton-loader>-->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <p>คำอธิบาย</p>
                  <!-- <quill-editor
                    class="editor"
                    v-model="description"
                    ref="description"
                    :value="description"
                    :options="editorOption"
                    @change="onEditorChange"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)"
                  />-->
                  <v-textarea disabled no-resize outlined name="input-7-4" v-model="description"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="error" dark rounded outlined @click="reject" min-width="85px">ไม่อนุมัติ</v-btn> -->
          <v-btn
            color="primary"
            rounded
            :disabled="!valid3"
            @click="confirmVerify"
            min-width="85px"
          >อนุมัติ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNote" persistent max-width="800">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <v-icon left>mdi-message-draw</v-icon>ระบุเหตุผล/หมายเหตุ
            <!-- {{ (this.checkTeacher == "w") ? "ระบุเหตุผล/หมายเหตุ" : "ยกเลิกการอนุมัติ Teacher/Tutor" }} -->
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialogNote">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pr-5 pl-5">
          <v-form ref="form_reject" v-model="dialogNotevalid">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <p>
                    เหตุผล/หมายเหตุ
                    <span class="red--text">*</span>
                  </p>
                  <!-- <quill-editor
                    class="editor"
                    v-model="note"
                    ref="description"
                    :value="note"
                    :options="editorOption"
                    @change="onEditorChange"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)"
                  />-->
                  <v-textarea
                    outlined
                    name="input-7-4"
                    :rules="decriptionRules"
                    v-model="reject_note"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2"
            large
            dark
            rounded
            outlined
            @click="closeDialogNote"
          >ยกเลิก</v-btn>
          <v-btn
            color="primary"
            class="px-10 ma-2"
            large
            rounded
            @click="rejectNote"
            :disabled="!reject_note"
          >ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNoteCancel" persistent max-width="800">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <v-icon left>mdi-message-draw</v-icon>ยกเลิกการอนุมัติ Teacher/Tutor
            <!-- {{ (this.checkTeacher == "w") ? "ระบุเหตุผล/หมายเหตุ" : "ยกเลิกการอนุมัติ Teacher/Tutor" }} -->
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogNoteCancel = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pr-5 pl-5">
          <v-form ref="form" v-model="valid2">
            <v-container>
              <v-row>
                <v-col cols="8">
                  <div class="img-padding">
                    <v-avatar :color="`grey lighten-2`" elevation="3" size="80">
                      <v-img
                        :src="image == null ? imageProfileReady1  : image"
                        class="my-2 ml-auto mr-auto rounded-card img-md"
                        aspect-ratio="1"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-icon
                              v-if="imageProfileReady1"
                              class="mx-auto"
                              elevation="3"
                              size="80"
                            >mdi-account</v-icon>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <p
                            class="ma-2 px-5 md-fixed-width text-left font-weight-bold title"
                          >{{fullName}}</p>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <p class="ma-2 px-5 md-fixed-width text-left subtitle">{{email}}</p>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="chip-padding">
                    <v-chip class="ma-2" :color="this.checkTeacher=='w' ?'default':'primary'">
                      <v-avatar left>
                        <v-icon>{{this.checkTeacher=='w' ? 'mdi-account' : 'mdi-account-tie'}}</v-icon>
                      </v-avatar>
                      <p class="mb-0">{{this.checkTeacher=='w' ? 'ผู้ใช้ทั่วไป' : 'ครู/ผู้สอน'}}</p>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <p>
                    เหตุผล/หมายเหตุ
                    <span class="red--text">*</span>
                  </p>
                  <!-- <quill-editor
                    class="editor"
                    v-model="note"
                    ref="description"
                    :value="note"
                    :options="editorOption"
                    @change="onEditorChange"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)"
                  />-->
                  <v-textarea
                    outlined
                    name="input-7-4"
                    :rules="decriptionRules"
                    v-model="cancel_note"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            dark
            class="px-9 ma-2"
            large
            rounded
            outlined
            @click="dialogNoteCancel = false"
          >ยกเลิก</v-btn>
          <v-btn
            color="error darken-1"
            rounded
            class="px-10 ma-2"
            large
            @click="cancelTutor"
            :disabled="cancel_note==''"
          >เพิกถอน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatus" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">คุณต้องการระงับผู้ใช้งานนี้หรือไม่</v-card-title>
        <v-card-text>เมื่อระงับการใช้งานแล้ว สามารถกลับมาเปิดการใช้งานได้ภายหลัง</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2"
            large
            dark
            rounded
            outlined
            @click="dialogStatus = false"
          >ยกเลิก</v-btn>
          <v-btn
            color="error darken-1"
            class="px-10 ma-2"
            large
            dark
            rounded
            @click="userUpdateActive()"
          >ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatusActive" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">คุณต้องการเปิดผู้ใช้งานนี้หรือไม่</v-card-title>
        <v-card-text>เป็นการเปลี่ยนสถานะผู้ใช้งานให้กลับมาใช้งานได้อีกครั้ง</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2"
            large
            dark
            rounded
            outlined
            @click="dialogStatusActive = false"
          >ยกเลิก</v-btn>
          <v-btn
            color="green darken-1"
            class="px-10 ma-2"
            large
            dark
            rounded
            @click="userUpdateActive()"
          >ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">บันทึกเรียบร้อย</v-card-title>

        <v-card-text>สามารถเปิด/ปิดการใช้งานได้ภายหลัง</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">เสร็จสิ้น</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">ยืนยันคำอนุมัติสำเร็จ</v-card-title>

        <v-card-text>เราได้บันทึกข้อมูลของคุณแล้ว</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="btnDialogSuccess()">เสร็จสิ้น</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddFail" max-width="450">
      <v-card>
        <v-card-title class="headline">ยืนยันคำอนุมัติไม่สำเร็จ</v-card-title>

        <v-card-text>เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1" text @click="dialogAddFail = false">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">แก้ไขผู้ใช้งานสำเร็จ</v-card-title>

        <v-card-text>เราได้บันทึกข้อมูลของคุณแล้ว</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogEditSuccess = false, dialogFormUser = false"
          >เสร็จสิ้น</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditFail" max-width="450">
      <v-card>
        <v-card-title class="headline">แก้ไขผู้ใช้งานไม่สำเร็จ</v-card-title>

        <v-card-text>เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1" text @click="dialogEditFail = false">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUsernameDuplicade" max-width="450">
      <v-card>
        <v-card-title class="headline">บันทึกไม่สำเร็จ</v-card-title>

        <v-card-text>อีเมล หรือชื่อผู้ใช้นี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" text @click="dialogUsernameDuplicade = false">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUserGroupSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">จัดกลุ่มผู้ใช้งานสำเร็จ</v-card-title>

        <v-card-text>เราได้บันทึกข้อมูลของคุณแล้ว</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogUserGroupSuccess = false, dialogGroupUser = false"
          >เสร็จสิ้น</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center">
      <v-dialog v-model="alert" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">ขออภัย</v-card-title>
          <v-card-text>
            คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ
            <strong>&nbsp;กำหนดสิทธิ์&nbsp;</strong>การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="alert = false">ตกลง</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <div class="pt-3 pr-3 pb-5">
      <v-pagination
        v-model="page"
        :length="pageCount"
        @input="changePage"
        color="rgb(66, 154, 216)"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
// import { getCourse } from "@/service/course/course";
import {
  register,
  updateUser,
  updateActive,
  getUserEditByID,
  getUserGroup,
  addUserGroup,
  getUserTeacherList,
  verifyUserTeacher
} from "@/service/account/manageUser";
import { uploadImage } from "@/service/upload/upload";
// import { loadCategory } from "@/service/category/category";
// import { loadSkill } from "@/service/skill/skill";

export default {
  data: () => ({
    alert: false,
    valid: true,
    valid2: true,
    valid3: true,
    dialogFormUser: false,
    dialogGroupUser: false,
    dialogStatus: false,
    dialogStatusActive: false,
    dialogSuccess: false,
    filterdialog: false,
    deleteDialog: false,
    dialogAddSuccess: false,
    dialogAddFail: false,
    dialogEditSuccess: false,
    dialogUserGroupSuccess: false,
    dialogEditFail: false,
    dialogUsernameDuplicade: false,
    dialogUserConfirm: false,
    dialogNote: false,
    dialogNoteCancel: false,
    isEdit: false,
    formDisabled: false,
    checkboxPassword: false,
    checkboxPasswordHide: true,
    showPassword: false,
    showConFirmPassword: false,

    permissionStudentAll: false,
    permissionCourseAll: false,

    viewStudent: false, //ข้อมูลผู้ใช้
    insertStudent: false, //เพิ่มรายชื่อ
    updateStudent: false, //แก้ไขรายชื่อผู้ใช้
    activeStudent: false, //ระงับการใช้งาน

    checkIsTeacher: false,
    isTeacher: "n",

    viewCourse: false, //เข้าถึงคอร์ส
    insertCourse: false, //เพิ่มคอร์ส
    updateCourse: false, //แก้ไขคอร์ส
    activeCourse: false, //ระงับคอร์ส
    manageCategory: false, //จัดการ Category
    viewReport: false, //เข้าถึงการรายงาน
    userGroup: false, //จัดการกลุ่มผู้ใช้

    arrayGroup: [],
    editUser: {},
    loading: true,
    imgPreview: "",
    imgPreview1: null,
    imgPreview2: null,
    description: "",
    note: "",
    checkTeacher: "",
    imageFile: null,
    imageReady: false,
    imageProfileReady: false,
    imageProfileReady1: false,
    imageReady1: false,
    imageReady2: false,
    users: [],
    teachers: [],
    groupUsers: [],
    selectionGroup: [],
    selection: [],
    editorOption: {},

    // selectionGroup: [{
    //       id: 1,
    //       name: 'Applications :',
    //       children: [
    //         { id: 2, name: 'Calendar : app' },
    //         { id: 3, name: 'Chrome : app' },
    //         { id: 4, name: 'Webstorm : app' },
    //       ],
    //     },],
    imageRules: [
      v => !!v || "กรุณาเลือกอัพโหลดรูปภาพ",
      v => v.size < 20000000 || "กรุณาเลือกไฟล์ที่มีขนาดน้อยกว่า 20 MB"
    ],
    nameRules: [v => !!v || "กรุณากรอกข้อมูลให้ครบถ้วน"],
    genderRules: [v => !!v || "กรุณาระบุเพศ"],
    firstNameRules: [v => !!v || "กรุณากรอกชื่อจริง"],
    lastNameRules: [v => !!v || "กรุณากรอกนามสกุล"],
    idCardNumberRules: [v => !!v || "กรุณากรอกเลขบัตรประจำตัวประชาชน"],
    userNameRules: [v => !!v || "กรุณากรอกชื่อผู้ใช้งาน"],
    passwordRules: [
      v => v.length >= 8 || "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป"
    ],
    decriptionRules: [v => !!v || "กรุณาระบุเหตุผล หรือ หมายเหตุ"],

    emailRules: [
      v => !!v || "กรุณากรอกอีเมล",
      v => /.+@.+\..+/.test(v) || "กรุณากรอกให้อยู่ในรูปแบบอีเมล"
    ],

    searchby: "ทั้งหมด",
    searchType: ["ทั้งหมด", "อนุมัติแล้ว", "รออนุมัติ"],
    sortType: [
      "เวลา สูง-ต่ำ",
      "เวลา ต่ำ-สูง",
      "ยอดนิยม สูง-ต่ำ",
      "ยอดนิยม ต่ำ-สูง"
    ],
    status_toggle: 0,
    headers: [
      {
        text: "PHOTO",
        align: "center",
        sortable: false,
        value: "image"
      },
      {
        text: "NAME",
        value: "fullName",
        align: "start",
        sortable: false
      },
    //   { text: "EMAIL", value: "email", align: "start", sortable: false },
      {
        text: "USERNAME",
        value: "username",
        align: "start",
        sortable: false
      },
      // { text: "TYPE", value: "type", align: "start", sortable: false },
      // {
      //   text: "STUDY/COURSE",
      //   value: "course",
      //   align: "start",
      //   sortable: false
      // },
      { text: "GROUP", value: "group", align: "start", sortable: false },
      // {
      //   text: "USER STATUS",
      //   value: "active",
      //   align: "start",
      //   sortable: false
      // },
      { text: "APPROVAL", value: "approve", align: "center", sortable: false },
    //   {
    //     text: "",
    //     value: "actions",
    //     align: "center",
    //     sortable: false
    //   }
    ],
    tab: 0,
    editUserId: "",
    firstName: "",
    lastName: "",
    selectedGender: null,
    email: "",
    username: "",
    password: "",
    conFirmPassword: "",
    image: null,
    searchdata: "",
    sortData: "",
    searchCourse: null,
    pageCount: 1,
    page: 1,
    limit: 10,
    searchStudent: null,
    category: [],
    skill: [],
    selectedSkill: [],
    selectedCategory: [],
    active: "null",
    params: {},
    deleteItemID: [],
    genders: [
      {
        text: "ชาย",
        value: "male"
      },
      {
        text: "หญิง",
        value: "female"
      },
      {
        text: "ไม่ระบุ",
        value: null
      }
    ],

    reject_note: "",
    cancel_note: "",

    oldDetailUser: null
  }),
  computed: {
    conFirmPasswordRules() {
      const rules = [];
      if (this.password) {
        const rule = v =>
          (!!v && v) === this.password || "กรุณากรอกรหัสผ่านให้ตรงกัน";
        rules.push(rule);
      }
      return rules;
    }
  },

  mounted() {
    this.initialize();
  },

  watch: {
    searchdata(keyword) {
      this.searchInfo(keyword);
    }
  },

  methods: {
    async initialize() {
      this.params = {
        search: null,
        sort: "created_at",
        sortby: -1,
        page: 1,
        limit: 10,
        active: "null",
        isTeacher: "w"
      };

      if (!this.$store.state.permission.viewStudent) {
        this.noPermission();
      } else {
        await this.getUserGroupList();
        await this.getTeacherList();
      }
    
      this.loading = false;
      this.status_toggle = 0;
      this.selectedSkill = [];
      this.selectedCategory = [];
      this.searchdata = "";
      this.active = "null";
      // await this.getUserGroupList()
    },

    async changePage(page) {
      this.params.page = page;
      await this.getTeacherList();
    },

    async getUserGroupList() {
      let result = await getUserGroup(this.params);
      this.groupUsers = [];
      // let userGroupAllAtIndex=[]
      this.arrayGroup = [];
      await result.forEach(async group => {
        // let arrayGroup = []
        group.child_User_Group.length === 0
          ? await this.arrayGroup.push({
              title: group.title,
              _id: group._id
            })
          : null;
        group.child_User_Group.forEach(async child => {
          child.child_User_Group.length === 0
            ? await this.arrayGroup.push({
                title: group.title + " -> " + child.title,
                _id: child._id
              })
            : null;
          child.child_User_Group.forEach(async lastChild => {
            await this.arrayGroup.push({
              title:
                group.title + " -> " + child.title + " -> " + lastChild.title,
              _id: lastChild._id
            });
          });
        });
        // await userGroupAllAtIndex.push({arrayGroup})
      });
      console.log(result);
      this.groupUsers = result;
    },
    async showGroupList(userGroup) {
      console.log(userGroup);
      console.log(this.arrayGroup);
      let userGroupOutput = [];
      await userGroup.forEach(
        async grouplist =>
          await this.arrayGroup.forEach(async group =>
            group._id == grouplist._id
              ? await userGroupOutput.push(group)
              : null
          )
      );
      console.log(userGroupOutput);
      return userGroupOutput;
    },
    removeByUser(item) {
      const index = this.selection.indexOf(item._id);
      if (index >= 0) this.selection.splice(index, 1);
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },

    // onUpdate(selectionGroup) {
    //   console.log("selectionGroup", selectionGroup);
    // },

    changeState() {
      this.insertStudent = false; //เพิ่มรายชื่อ
      this.updateStudent = false; //แก้ไขรายชื่อผู้ใช้
      this.activeStudent = false; //ระงับการใช้งาน
    },
    changeStateUpdate() {
      if (this.insertStudent == false && this.updateStudent == false) {
        this.activeStudent = false; //ระงับการใช้งาน
      }
    },

    changeStateCourse() {
      this.insertCourse = false; //เพิ่มคอร์ส
      this.updateCourse = false; //แก้ไขคอร์ส
      this.activeCourse = false; //ระงับคอร์ส
    },
    changeStateUpdateCourse() {
      if (this.insertCourse == false && this.updateCourse == false) {
        this.activeCourse = false; //ระงับคอร์ส
      }
    },

    refreshFilter() {
      this.initialize();
    },

    onSort() {
      // if (this.searchby == "อนุมัติแล้ว") {
      //   this.params.isTeacher = "y";
      //   this.getTeacherList();
      // } else if (this.searchby == "รออนุมัติ") {
      //   this.params.isTeacher = "w";
      //   this.getTeacherList();
      // } else {
      //   this.params.isTeacher = "";
      //   this.getTeacherList();
      // }

      if (this.status_toggle == 1) {
        // this.params.isTeacher = "y";
        this.params.active = true;
        this.getTeacherList();
      } else if (this.status_toggle == 2) {
        // this.params.isTeacher = "w";
        this.params.active = false;
        this.getTeacherList();
      } else {
        // this.params.isTeacher = "";
        this.params.active = null;
        this.getTeacherList();
      }
    },

    async preview() {
      if (this.imageFile != null) {
        this.imgURL = await this.uploadImg(this.imageFile);
        this.imgPreview = this.imgURL;
        this.imageReady = true;
        console.log("UPLOADED IMAGE:", this.imgPreview);
      } else {
        this.imageReady = false;
      }
    },

    async uploadImg(image) {
      let status = await uploadImage("user", image);
      return status;
    },

    searchInfo(keyword) {
      this.params.search = keyword;

      this.getTeacherList();
    },

    applyFilter() {
      this.filterdialog = false;
      let skills = this.selectedSkill.map(skill => skill._id);
      let category = this.selectedCategory._id;

      this.params.skill = skills;
      this.params.category = category;
      this.params.active = this.active;

      this.getTeacherList();
    },

    openModalStatus(item) {
      let index = this.teachers.indexOf(item);
      if (this.teachers[index].active == true) {
        this.dialogStatus = true;
        console.log(index);
        console.log(this.teachers[index].id);
        console.log(this.teachers[index].active);
        this.updateActiveId = this.teachers[index].id;
        this.updateActive = this.teachers[index].active;
      } else {
        this.dialogStatusActive = true;
        this.updateActiveId = this.teachers[index].id;
        this.updateActive = this.teachers[index].active;
      }
    },

    async getTeacherList() {
      this.loading = true;
      // localStorage.removeItem("editCourseID");
      let resultTeacher = await getUserTeacherList(this.params);
      console.log("teacher list ", resultTeacher);
      let result = await resultTeacher.data.filter(
        filter => filter.isTeacher === "w"
      );
      console.log("RESULT",result);
      this.teachers = [];
    //   this.pageCount = Math.ceil(result.length / this.limit)
      console.log(resultTeacher);
      this.pageCount = resultTeacher.maxPage;
      await result.forEach(async teacher => {
        this.teachers.push({
          id: teacher._id,
          image: teacher.image,
          fullName: teacher.firstName + " " + teacher.lastName,
          email: teacher.email,
          username: teacher.username,
          course: {
            buy: teacher.countBuyCourse,
            create: teacher.countCourseCreate
          },
          active: teacher.active,
          group: await this.showGroupList(teacher.user_groups),
          isTeacher: teacher.isTeacher,
          verifyTeacher: teacher.verifyTeacher
        });
      });
      this.imageReady = true;
      this.loading = false;
    },

    async getUserGroup(item) {
      this.dialogGroupUser = true;
      this.editUserId = item.id;
      let index = this.users.indexOf(item);

      // let result = await getUserGroup(this.params);
      // this.groupUsers = [];
      // // let userGroupAllAtIndex=[]
      // this.arrayGroup = []
      // await result.forEach(async group =>{
      //   // let arrayGroup = []
      //   group.child_User_Group.length === 0?
      //   await this.arrayGroup.push({
      //       title: group.title,
      //     _id: group._id
      //   })
      //   : null
      //   group.child_User_Group.forEach(async child=> {
      //     child.child_User_Group.length === 0 ?
      //       await this.arrayGroup.push({
      //       title: group.title + " -> " + child.title,
      //       _id: child._id
      //     })
      //     : null
      //       child.child_User_Group.forEach(async lastChild => {
      //         await this.arrayGroup.push({
      //         title: group.title + " -> " + child.title+ " -> " +lastChild.title,
      //         _id: lastChild._id
      //       })
      //     })
      //   })
      //   // await userGroupAllAtIndex.push({arrayGroup})
      // })
      // this.groupUsers = result;

      console.log("groupUsers", this.groupUsers);
      if (this.editUserId) {
        // this.selection = [];
        // this.users[index].group.forEach(setValueGroup => {
        //   this.selection.push(setValueGroup._id);
        // });
        console.log(index);
        this.selection = await item.group.map(group => group._id);
      }
      console.log("set data", this.selection);
    },

    async getUserEdit(item) {
      console.log(this.isEdit);
      let result = await getUserEditByID({ idstudent: item.id });
      console.log("result ", result);
      this.oldDetailUser = result;
      this.editUserId = item.id;
      this.editUserCompanies = result.companies[0];
      this.imgPreview = result.image;
      this.imageReady = true;
      this.selection = result.user_groups;
      let gen = this.genders.filter(gender => gender.value == result.gender);
      if (gen.length > 0) {
        this.selectedGender = gen[0].value;
      } else {
        this.selectedGender = null;
      }
      this.firstName = result.firstName;
      this.lastName = result.lastName;
      this.email = result.email;
      this.username = result.username;
      this.isTeacher = result.isTeacher;
      //permission//
      this.viewStudent = result.permission.viewStudent; //ข้อมูลผู้ใช้
      this.insertStudent = result.permission.insertStudent; //เพิ่มรายชื่อ
      this.updateStudent = result.permission.updateStudent; //แก้ไขรายชื่อผู้ใช้
      this.activeStudent = result.permission.activeStudent; //ระงับการใช้งาน

      this.viewCourse = result.permission.viewCourse; //เข้าถึงคอร์ส
      this.insertCourse = result.permission.insertCourse; //เพิ่มคอร์ส
      this.updateCourse = result.permission.updateCourse; //แก้ไขคอร์ส
      this.activeCourse = result.permission.activeCourse; //ระงับคอร์ส

      this.manageCategory = result.permission.viewCategory; //จัดการ Category

      this.viewReport = result.permission.viewReport; //เข้าถึงการรายงาน

      this.userGroup = result.permission.viewUserGroup; //จัดการกลุ่มผู้ใช้
    },

    async insertOrUpdateUserGroup() {
      // let arrayParent = [];
      // this.selection.forEach(id => {
      //   this.groupUsers.forEach((root, index) => {
      //     if (id == root.id) {
      //       console.log(index);
      //     }
      //     root.children.forEach(sub1 => {
      //       if (id == sub1.id) {
      //         console.log(root.name);
      //         arrayParent.push(root.id);
      //       }
      //       sub1.children.forEach(sub2 => {
      //         if (id == sub2.id) {
      //           console.log(sub1.name);
      //           arrayParent.push(root.id);
      //           arrayParent.push(sub1.id);
      //         }
      //       });
      //     });
      //   });
      // });
      // let groupId = [...this.selection, ...arrayParent];
      console.log(this.selection);
      let result = await addUserGroup({
        id: this.editUserId,
        // user_groups: groupId.filter((id, index) => groupId.indexOf(id) == index)
        // user_groups: []
        user_groups: this.selection
      });
      console.log(result);
      if (result.code != 200) {
        this.dialogUserGroupSuccess = true;
        await this.getTeacherList();
      }
    },

    async insertOrUpdateUser() {
      this.$refs.form.validate();
      console.log(this.isEdit);
      if (this.isEdit == true) {
        if (this.imgPreview) {
          this.preview();
        }
        let status = await updateUser({
          ...this.oldDetailUser,
          id: this.editUserId,
          companies: this.editUserCompanies,
          image: this.imgPreview,
          firstName: this.firstName,
          lastName: this.lastName,
          gender: this.selectedGender,
          email: this.email,
          username: this.username,
          password: this.password,
          isTeacher: this.isTeacher,
          user_groups: this.selection,
          permission: {
            viewTutor: false,
            viewStudent: this.viewStudent, //ข้อมูลผู้ใช้
            insertStudent: this.insertStudent, //เพิ่มรายชื่อ
            updateStudent: this.updateStudent, //แก้ไขรายชื่อผู้ใช้
            activeStudent: this.activeStudent, //ระงับการใช้งาน

            viewCourse: this.viewCourse, //เข้าถึงคอร์ส
            insertCourse: this.insertCourse, //เพิ่มคอร์ส
            updateCourse: this.updateCourse, //แก้ไขคอร์ส
            activeCourse: this.activeCourse, //ระงับคอร์ส

            viewCategory: this.manageCategory, //จัดการ Category
            insertCategory: this.manageCategory, //จัดการ Category
            updateCategory: this.manageCategory, //จัดการ Category
            activeCategory: this.manageCategory, //จัดการ Category

            viewReport: this.viewReport, //เข้าถึงการรายงาน

            viewCompany: false,
            insertCompany: false,
            updateCompany: false,
            activeCompany: false,

            viewUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
            insertUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
            updateUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
            activeUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้

            accessBI: false
          }
        });
        console.log(status);
        // return status
        //ตอนนี้มี error อันเดียว คือ usernameซ้ำเลยใช้ if 403
        // if (status.code != 200) {
        //   this.dialogEditSuccess = true;
        //   this.getUserList();
        // } else {
        //   this.dialogEditFail = true; //กรณี error อื่น
        //   this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
        // }
        if (status.message == "username or email duplicade") {
          this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
        } else if (status.code == 403) {
          this.dialogEditFail = true; //กรณี error อื่น
        } else {
          this.dialogEditSuccess = true;
          await this.getTeacherList();
        }
      } else {
        let status = await register({
          image: this.imgURL,
          gender: this.selectedGender,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          username: this.username,
          password: this.password,
          isTeacher: this.isTeacher,
          user_groups: this.selection,
          permission: {
            viewTutor: false,
            viewStudent: this.viewStudent, //ข้อมูลผู้ใช้
            insertStudent: this.insertStudent, //เพิ่มรายชื่อ
            updateStudent: this.updateStudent, //แก้ไขรายชื่อผู้ใช้
            activeStudent: this.activeStudent, //ระงับการใช้งาน

            viewCourse: this.viewCourse, //เข้าถึงคอร์ส
            insertCourse: this.insertCourse, //เพิ่มคอร์ส
            updateCourse: this.updateCourse, //แก้ไขคอร์ส
            activeCourse: this.activeCourse, //ระงับคอร์ส

            viewCategory: this.manageCategory, //จัดการ Category
            insertCategory: this.manageCategory, //จัดการ Category
            updateCategory: this.manageCategory, //จัดการ Category
            activeCategory: this.manageCategory, //จัดการ Category

            viewReport: this.viewReport, //เข้าถึงการรายงาน

            viewCompany: false,
            insertCompany: false,
            updateCompany: false,
            activeCompany: false,

            viewUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
            insertUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
            updateUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
            activeUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้

            accessBI: false
          }
        });
        // return status
        if (status.message == "username or email duplicade") {
          this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
        } else if (status.code == 403) {
          this.dialogAddFail = true; //กรณี error อื่น
        } else {
          this.dialogAddSuccess = true;
          await this.getTeacherList();
        }
      }
    },

    async userEdit(item) {
      this.dialogFormUser = true;
      this.imageReady = true;

      if (item) {
        this.isEdit = true;
        this.getUserEdit(item);
        this.checkboxPassword = false;
        this.checkboxPasswordHide = true;
      } else {
        this.isEdit = false;
        this.checkboxPassword = true;
        this.checkboxPasswordHide = false;
        this.$refs.form.resetValidation();

        this.firstName = "";
        this.lastName = "";
        this.gender = "";
        this.email = "";
        this.username = "";
        this.password = "";
        this.conFirmPassword = "";
        this.image = "";
        this.imgPreview = "";
        (this.imageFile = null), (this.viewStudent = false); //ข้อมูลผู้ใช้
        this.insertStudent = false; //เพิ่มรายชื่อ
        this.updateStudent = false; //แก้ไขรายชื่อผู้ใช้
        this.activeStudent = false; //ระงับการใช้งาน

        this.viewCourse = false; //เข้าถึงคอร์ส
        this.insertCourse = false; //เพิ่มคอร์ส
        this.updateCourse = false; //แก้ไขคอร์ส
        this.activeCourse = false; //ระงับคอร์ส

        this.manageCategory = false; //จัดการ Category

        this.viewReport = false; //เข้าถึงการรายงาน

        this.userGroup = false; //จัดการกลุ่มผู้ใช้
      }
    },
    clearForm() {
      this.dialogFormUser = false;
      this.isEdit = false;
      this.checkboxPassword = true;
      this.checkboxPasswordHide = false;
      this.$refs.form.resetValidation();

      this.tab = 0;

      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.username = "";
      this.password = "";
      this.conFirmPassword = "";
      this.image = "";
      this.imgPreview = "";
      (this.imageFile = null), (this.viewStudent = false); //ข้อมูลผู้ใช้
      this.insertStudent = false; //เพิ่มรายชื่อ
      this.updateStudent = false; //แก้ไขรายชื่อผู้ใช้
      this.activeStudent = false; //ระงับการใช้งาน

      this.viewCourse = false; //เข้าถึงคอร์ส
      this.insertCourse = false; //เพิ่มคอร์ส
      this.updateCourse = false; //แก้ไขคอร์ส
      this.activeCourse = false; //ระงับคอร์ส

      this.manageCategory = false; //จัดการ Category

      this.viewReport = false; //เข้าถึงการรายงาน

      this.userGroup = false; //จัดการกลุ่มผู้ใช้
    },

    async userUpdateActive() {
      if (this.updateActive == true) {
        let status = await updateActive({
          id: this.updateActiveId,
          active: false
        });
        this.dialogStatus = false;
        this.dialogSuccess = true;
        await this.getTeacherList();
        return status;
      } else {
        let status = await updateActive({
          id: this.updateActiveId,
          active: true
        });
        this.dialogStatusActive = false;
        this.dialogSuccess = true;
        await this.getTeacherList();
        return status;
      }
    },

    async userConfirm(item) {
      this.dialogUserConfirm = true;
      this.imageReady1 = true;
      this.imageReady2 = true;
      this.imageProfileReady = true;
      this.editUserId = item.id;
      let index = this.teachers.indexOf(item);
      console.log("teacher id ", this.editUserId);
      console.log("teacher index ", index);
      console.log("result teacher", this.teachers);
      console.log(this.teachers[index].verifyTeacher);
      this.getUserEdit(item);
      if (this.editUserId) {
        this.teachers[index].verifyTeacher.map(
          (this.image = this.teachers[index].image),
          (this.email = this.teachers[index].email),
          (this.fullName = this.teachers[index].fullName),
          (this.imgPreview1 = this.teachers[index].verifyTeacher.image[0]),
          (this.imgPreview2 = this.teachers[index].verifyTeacher.image[1]),
          (this.description = this.teachers[index].verifyTeacher.description)
        );
      }
    },

    closeDialog() {
      this.dialogUserConfirm = false;
    },

    reject(item) {
      this.editUserId = item.id;
      this.dialogNote = true;
    },

    async rejectNote() {
      let status = await verifyUserTeacher({
        id: this.editUserId,
        isTeacher: "r",
        note: this.reject_note
      });
      this.dialogAddSuccess = true;
      this.closeDialogNote();
      this.getTeacherList();
      console.log("ไม่อนุมัติ ", status);
    },
    async cancelTutor() {
      let status = await verifyUserTeacher({
        id: this.editUserId,
        isTeacher: "n",
        note: this.cancel_note
      });
      this.dialogAddSuccess = true;
      await this.getTeacherList();
      console.log("ไม่อนุมัติ ", status);
    },

    async changTutorToUser(item) {
      this.editUserId = item.id;
      let index = this.teachers.indexOf(item);
      this.dialogNoteCancel = true;
      this.imageProfileReady1 = true;
      if (this.editUserId) {
        this.teachers[index].verifyTeacher.map(
          (this.image = this.teachers[index].image),
          (this.email = this.teachers[index].email),
          (this.fullName = this.teachers[index].fullName)
        );
      }
    },

    async confirmVerify() {
      let status = await verifyUserTeacher({
        id: this.editUserId,
        isTeacher: "y",
        note: "ผ่าน"
      });
      let result = await updateUser({
        id: this.editUserId,
        companies: this.editUserCompanies,
        image: this.imgPreview,
        firstName: this.firstName,
        lastName: this.lastName,
        identificationNumber: this.idCardNumber,
        email: this.email,
        username: this.username,
        password: this.password,
        isTeacher: "y",
        gender: this.selectedGender,
        user_groups: this.selection,
        permission: {
          viewTutor: false,
          viewStudent: false,
          insertStudent: false,
          updateStudent: false,
          activeStudent: false,
          viewCourse: true,
          insertCourse: true,
          updateCourse: true,
          activeCourse: true,
          viewCategory: false,
          insertCategory: false,
          updateCategory: false,
          activeCategory: false,
          viewReport: false,
          viewCompany: false,
          insertCompany: false,
          updateCompany: false,
          activeCompany: false,

          viewUserGroup: false,
          insertUserGroup: false,
          updateUserGroup: false,
          activeUserGroup: false,
          accessBI: false
        }
      });
      console.log(status);

      this.dialogAddSuccess = true;
      await this.getTeacherList();
      console.log("อนุมัติ ", status);
      console.log("set permission ", result);
    },
    async btnDialogSuccess() {
      this.dialogAddSuccess = false;
      this.dialogNote = false;
      this.dialogUserConfirm = false;

      this.dialogNoteCancel = false;
      await this.getTeacherList();
    },
    closeDialogNote() {
      this.reject_note = "";
      this.$refs.form_reject.resetValidation();
      this.dialogNote = false;
    },
    setPermission(item) {
      let index = this.teachers.indexOf(item);
      this.checkTeacher = this.teachers[index].isTeacher;
      if (this.$store.state.permission.updateStudent == true) {
        if (item.isTeacher == "w") {
          this.userConfirm(item);
        } else if (item.isTeacher == "y") {
          this.changTutorToUser(item);
        }
      } else {
        this.noPermission();
      }
    },
    noPermission() {
      console.log("no permission");
      this.alert = true;
    }
  }
};
</script>
<style scoped>
.main {
  background-color: rgb(241, 243, 245);
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.title-text {
  color: rgb(140, 140, 140);
}

.text-field-border {
  border: 1px solid;
  border-radius: 8px;
  border-color: rgba(65, 65, 65, 0.3);
  height: 40px;
}

.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #ccc !important;
}

.theme--light.v-input--is-disabled,
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: black;
}
.rounded-card {
  border-radius: 8px;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
}
.v-dialog--scrollable > .v-card > .v-card__text,
.v-dialog--scrollable > form > .v-card > .v-card__text {
  padding-bottom: 0px;
}
.v-input__append-inner {
  margin-top: 9px !important;
}
.md-fixed-max-width {
  max-width: 220px;
}
.max-width {
  width: 100%;
}
.img-md {
  width: 50px;
}
.editor {
  height: 200px;
  margin-bottom: 70px;
}
.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}
.chip-padding {
  text-align: right;
}

@media only screen and (max-width: 1440px) {
  .md-fixed-width {
    width: 130px;
  }
  .xs-fixed-width {
    width: 80px;
  }
}
@media only screen and (max-width: 768px) {
  .img-md {
    width: 50px;
    height: 50px;
  }
  .md-fixed-width {
    width: 130px;
  }
  .xs-fixed-width {
    width: 100px;
  }
  .xs-m {
    margin-top: 28px !important;
  }
  .xs-full-max-width {
    max-width: 100%;
  }
  .table-header {
    height: auto !important;
  }
  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column;
    padding: 0 !important;
  }
  .xs-full-width {
    width: 50%;
  }
}
</style>
